<div style="--swiper-navigation-color: var(--theme-color); --swiper-pagination-color: var(--theme-color)"
     class="swiper hero-swiper">
  <div data-swiper-parallax="-23%"></div>
  <div class="swiper-wrapper">
    <div class="swiper-slide" *ngFor="let slide of slides">
      <img class="hero-bg" [src]="slide.background" alt="background"/>
      <img [src]="slide.img" alt="img" class="hero-img"/>
      <div class="hero-left">
        <h2>{{ slide.title }}</h2>
        <p>
          {{ slide.description }}
        </p>
        <br/>
        <a *ngIf="slide.url" [href]="slide.url" target="_blank" class="slide-button">
          <p>
            {{ slide.buttonText }}
          </p>
          <i class="fas fa-caret-right" aria-hidden="true"></i>
        </a>
      </div>

    </div>
  </div>
  <div class="swiper-button-next"></div>
  <div class="swiper-button-prev"></div>
  <div class="swiper-pagination"></div>
</div>

<div class="counters">
  <a [href]="environmentCommon.website.github.url + '/' + environmentCommon.company.social.github"
     class="counter-wrapper" rel="noopener" target="_blank">
    <app-text-content-loader *ngIf="npmCounterLoading" [size]="'30'" class="loader"></app-text-content-loader>
    <p [hidden]="npmCounterLoading" class="counter" id="npmDownloadCounterElement"></p>
    <p class="description" i18n="@@homePage.npmDownloads">Npm Downloads</p>
  </a>
  <a [href]="environmentCommon.website.github.url + '/' + environmentCommon.company.social.github"
     class="counter-wrapper counter-alter" rel="noopener" target="_blank">
    <app-text-content-loader *ngIf="githubCounterLoading" [size]="'30'" class="loader"></app-text-content-loader>
    <p [hidden]="githubCounterLoading" class="counter" id="totalStarsCounterElement">0</p>
    <p class="description" i18n="@@homePage.totalStars">Total GitHub Stars</p>
  </a>
  <a [href]="environmentCommon.website.github.url + '/' + environmentCommon.company.social.github"
     class="counter-wrapper" rel="noopener" target="_blank">
    <div class="ratio">
      <p class="counter" id="openSourceRatioCounterElement">0</p>
      <span class="counter">%</span>
    </div>
    <p class="description" i18n="@@homePage.openSourceRatio">Open Source Ratio</p>
  </a>
</div>

<!-- Testimonials -->
<oth-hero [contents]="testimonialsTitle"></oth-hero>
<div class="cards-wrapper">
  <app-testimonial-card
      *ngFor="let testimonial of TESTIMONIALS"
      [testimonial]="testimonial">
  </app-testimonial-card>
  <oth-button [buttonClasses]="['lighter-contrast-border-color', 'lighter-contrast-font-color', 'transparent-button']"
              [routerLink]="URLS.customers" i18n-text="@@productPage.readMoreStories"
              text="Read More Stories">
  </oth-button>
</div>

<!-- Customers -->
<oth-hero [contents]="customersTitle"></oth-hero>
<div class="customers-wrapper">
  <app-business-partner-swiper [partners]="PARTNERS">
  </app-business-partner-swiper>
</div>

<!-- Why Us -->
<oth-hero [contents]="whyUsTitle"></oth-hero>
<div class="cards-wrapper">
  <app-feature-card
      *ngFor="let feature of FEATURES"
      [feature]="feature">
  </app-feature-card>
</div>

<!-- Partnership Badges -->
<oth-hero [contents]="partnershipBadgesTitle"></oth-hero>
<div class="cards-wrapper">
  <ng-container *ngFor="let partner of PARTNERS; index as i">
    <img *ngIf="partner.badge" [alt]="partner.name" [src]="partner.badge" class="partner"/>
  </ng-container>
</div>

<!-- Explore -->
<oth-hero [contents]="exploreTitle"></oth-hero>
<ng-container *ngFor="let productLine of PRODUCT_LINES">
  <oth-hero [contents]="[{ text: productLine.name, level: 3 }]" [heroClass]="'no-padding'"></oth-hero>
  <div class="cards-wrapper">
    <ng-container *ngFor="let product of productLine.products">
      <app-presentation-card
          [class]="product.color ? product.color : ''"
          [footerText]=getPresentationCardFooter(product.openSource)
          [href]="product.redirectToUrl ? product.url : (URLS.product + '/' + productLine.key + '/' + product.key)"
          [imgHeight]="150"
          [maintenance]="product.url === URLS.maintenance"
          [secondaryText]="product.description"
          [src]="product.logo"
          [title]="product.name"
          class="related-product">
      </app-presentation-card>
    </ng-container>
  </div>
</ng-container>

<!-- And More -->
<oth-hero [contents]="andMoreTitle"></oth-hero>
<ng-container *ngFor="let productLine of LIBRARIES">
  <oth-hero [contents]="[{ text: productLine.name, level: 3 }]" [heroClass]="'no-padding'"></oth-hero>
  <div class="cards-wrapper">
    <ng-container *ngFor="let product of productLine.products">
      <app-presentation-card
          [class]="product.color ? product.color : ''"
          [footerText]=getPresentationCardFooter(product.openSource)
          [href]="product.url"
          [imgHeight]="150"
          [maintenance]="product.url === URLS.maintenance"
          [secondaryText]="product.description"
          [src]="product.logo"
          [title]="product.name"
          class="related-product">
      </app-presentation-card>
    </ng-container>
  </div>
</ng-container>
<ng-container *ngFor="let productLine of PLUGINS">
  <oth-hero [contents]="[{ text: productLine.name, level: 3 }]" [heroClass]="'no-padding'"></oth-hero>
  <div class="cards-wrapper">
    <ng-container *ngFor="let product of productLine.products">
      <app-presentation-card
          [class]="product.color ? product.color : ''"
          [footerText]=getPresentationCardFooter(product.openSource)
          [href]="product.urlAlter"
          [imgHeight]="150"
          [maintenance]="product.url === URLS.maintenance"
          [secondaryText]="product.description"
          [src]="product.logo"
          [title]="product.name"
          class="related-product">
      </app-presentation-card>
    </ng-container>
  </div>
</ng-container>

<app-cookies></app-cookies>
